import { render, staticRenderFns } from "./stock-move-location.vue?vue&type=template&id=672deb46&scoped=true"
import script from "./stock-move-location.vue?vue&type=script&lang=ts"
export * from "./stock-move-location.vue?vue&type=script&lang=ts"
import style0 from "./stock-move-location.vue?vue&type=style&index=0&id=672deb46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672deb46",
  null
  
)

export default component.exports